<template>
  <div class="page-column">
    <MatchHeader />
    <MatchInfo />
    <MatchMenu />
    <MatchCompany />
    <MatchProject />
    <Footer />
  </div>
</template>

<script>
import MatchHeader from '../layout/MatchHeader.vue'
import MatchInfo from '@comm/components/MatchInfo.vue'
import MatchMenu from '@comm/components/MatchMenu.vue'
import MatchCompany from '@comm/components/MatchCompany.vue'
import MatchProject from '@comm/components/MatchProject.vue'
import Footer from '../layout/Footer.vue'
export default {
  components: {
    MatchHeader,
    MatchInfo,
    MatchMenu,
    MatchCompany,
    MatchProject,
    Footer,
  },
  data() {
    return {
      info: {},
    }
  },
  created() {
    window.scrollTo(0, 0)
  },
  methods: {},
}
</script>
<style lang="scss" scoped>
.page-column {
  display: flex;
  flex-grow: 1;
  flex-direction: column;
}
</style>



// WEBPACK FOOTER //
// src/daoba-match/views/match/Detail.vue